import React, {Component} from 'react';
import '../comCss/NikeNeu.css';

class NikeCom extends Component {
   render(){ 
  return (
    <div class="project-view-section-2">
        <img src={process.env.PUBLIC_URL + "/images/Projects/NikeNeu/1nike.jpg"} class="pws1-nike-imgs" />
        <img src={process.env.PUBLIC_URL + "/images/Projects/NikeNeu/2nike.jpg"} class="pws1-nike-imgs" />
        <img src={process.env.PUBLIC_URL + "/images/Projects/NikeNeu/3nike.jpg"} class="pws1-nike-imgs" />
        <img src={process.env.PUBLIC_URL + "/images/Projects/NikeNeu/4nike.jpg"} class="pws1-nike-imgs" />
    </div>
  );
}
}
export default NikeCom;
